import DropSection from "../../components/drop-section/drop-section.components";
import { useState } from "react"; // اضافه کردن useState

const Home = () => {
  const [language, setLanguage] = useState("FA"); // مدیریت زبان

  return (
    <div>
      <DropSection />
    </div>
  );
};

export default Home;
